import Pusher from 'pusher-js'
import { getStorage } from '@/helpers/Local'

const PUSHER_WIGS_CREDENTIALS = {
    pusherAppId: process.env.VUE_APP_PUSHER_APP_ID,
    pusherAppKey: process.env.VUE_APP_PUSHER_APP_KEY,
    pusherAppSecret: process.env.VUE_APP_PUSHER_APP_SECRET,
    pusherAppCluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
}

const pusherCredentials = PUSHER_WIGS_CREDENTIALS

const token = getStorage('access_token')

const pusher = new Pusher(pusherCredentials.pusherAppKey, {
    cluster: pusherCredentials.pusherAppCluster,
    encrypted: false,
    channelAuthorization: {
        endpoint: '/base/api/broadcasting/auth',
        headers: {
            Authorization: token ? `Bearer ${token}` : '',
        },
    },
})

export default pusher
